"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given number is less than zero.
 *
 * @export
 * @class IsNegativeValidator
 * @implements {PropertyValidator<number>}
 */
class IsNegativeValidator {
    isValid(input) {
        if (input) {
            return input < 0;
        }
        return false;
    }
}
exports.IsNegativeValidator = IsNegativeValidator;
//# sourceMappingURL=IsNegativeValidator.js.map